module.exports = __webpack_public_path__ + "static/media/girl.1824af72.svg";